import { motion } from "framer-motion";

const stats = [
  { n: "$300B+", l: "Mobile accessories market" },
  { n: "500M+", l: "Pro iPhone users worldwide" },
  { n: "45%", l: "Growth in remote professionals" },
];

export const Stats = () => (
  <section id="market" data-testid="stats-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <p className="text-xs tracking-[0.25em] uppercase font-bold text-stone-500 mb-14 text-center">
        A market ready for a new category
      </p>
      <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-stone-200">
        {stats.map((s, i) => (
          <motion.div
            key={s.l}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            data-testid={`stat-${i}`}
            className="px-6 py-10 md:py-4 text-center"
          >
            <div className="font-serif text-6xl md:text-7xl text-stone-900 tracking-tight">{s.n}</div>
            <div className="mt-4 text-stone-500 text-sm md:text-base">{s.l}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
